import { render, staticRenderFns } from "./BotDataSourcesListCard.vue?vue&type=template&id=9c2acff2"
import script from "./BotDataSourcesListCard.vue?vue&type=script&lang=ts"
export * from "./BotDataSourcesListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports